(() => {
  const hash = '#figma-ecomm-section';
  const target = () => [...document.querySelectorAll(hash)].find(node => node.getBoundingClientRect().width > 0);
  const align = (behavior = 'auto') => {
    const section = target();
    if (!section) return;
    const headerHeight = innerWidth < 990 ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--daisy-mobile-header-height')) || 69 : 69;
    window.scrollTo({top: window.scrollY + section.getBoundingClientRect().top - headerHeight, behavior});
  };
  window.daisyScrollToEcomm = () => align(matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.hash !== hash || url.pathname !== location.pathname || !target() || new URLSearchParams(location.search).has('view')) return;
    event.preventDefault();
    history.replaceState(null, '', hash);
    align(matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  });
  let interacted = false;
  for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) window.addEventListener(type, () => { interacted = true; }, {once:true, passive:true});
  const initial = () => {
    if (location.hash === hash && !interacted) requestAnimationFrame(() => requestAnimationFrame(() => align()));
  };
  initial();
  document.fonts?.ready.then(initial);
  window.addEventListener('load', initial, {once:true});
})();
